import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DropdownFieldWUT } from '../../../ui/dropdown-field';
import { classes } from './dext-dropdown-wut.st.css';
export const DextDropdownWUT = _ref => {
  let {
    options,
    ...rest
  } = _ref;
  const fieldType = FIELD_TYPES.DEXT_DROPDOWN;
  const dropdownOptions = useMemo(() => (options || []).map(option => ({
    label: option.label,
    value: option.value ?? option.label
  })), [options]);
  return /*#__PURE__*/React.createElement(DropdownFieldWUT, _extends({}, rest, {
    fieldType: fieldType,
    options: dropdownOptions,
    className: classes.dextDropdown
  }));
};
//# sourceMappingURL=dext-dropdown-wut.js.map